import React from 'react';
import { Hero } from '../components/home/Hero';
import { CategoryShowcase } from '../components/home/CategoryShowcase';
import { BestSellers } from '../components/home/BestSellers';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { BrandStrip } from '../components/home/BrandStrip';
import { StatsContact } from '../components/home/StatsContact';
import { FaqSection } from '../components/home/FaqSection';
export function Home() {
  return <>
      <Hero data-id="element-744" data-mp="24gscw63ihrw5" />
      <CategoryShowcase data-id="element-745" data-mp="24gilqf6qdeov" />
      <div className="h-12 lg:h-16" aria-hidden="true" data-id="element-746" data-mp="24htnyakj2edv" />
      <BestSellers data-id="element-747" data-mp="29gdbgferry8c" />
      <ReviewsSection data-id="element-748" data-mp="29fvhxqjhry44" />
      <BrandStrip data-id="element-749" data-mp="29fbww0yjotlv" />
      <StatsContact data-id="element-750" data-mp="29etxivgl5z9q" />
      <FaqSection data-id="element-751" data-mp="2dhqi2rpos5gb" />
    </>;
}